import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import GameSession from './pages/GameSession';
import Home from './pages/Home';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import Account from './pages/Account';
import MadeWithAI from './pages/MadeWithAI';
import Header from './components/Header';
import './App.css';
import { GameProvider } from './contexts/GameContext';
import { PostHogPageView } from './providers/PostHogPageView';

function AppContent() {
  const location = useLocation();
  const isGamePage = location.pathname.startsWith('/g/');

  return (
    <>
      <PostHogPageView />
      {!isGamePage && <Header />}
      <Routes>
        <Route path="/g/:gameId" element={<GameSession />} />

        {/* Home landing page */}
        <Route path="/" element={<Home />} />

        {/* Auth routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/account" element={<Account />} />

        {/* Info pages */}
        <Route path="/made-with-ai" element={<MadeWithAI />} />

        {/* Fallback for any other unmatched routes */}
        <Route path="*" element={<div><h2>404 - Page Not Found</h2><p>The page you are looking for does not exist.</p></div>} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <GameProvider>
      <Router>
        <AppContent />
      </Router>
    </GameProvider>
  );
}

export default App;
